module.exports = __webpack_public_path__ + "static/media/logo-dark.66bd1de9.svg";